import React from 'react';
import Icon from '../../../components/AppIcon';

const DealProgressionTracker = ({ stages }) => {
  return (
    <div className="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-gray-200 dark:border-slate-700 p-6">
      <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-6">
        Deal Progression Stages
      </h2>
      <div className="flex items-center justify-between">
        {stages?.map((stage, index) => (
          <React.Fragment key={index}>
            <div className="flex flex-col items-center flex-1">
              <div className={`w-12 h-12 rounded-full ${stage?.color} flex items-center justify-center mb-2`}>
                <Icon name={stage?.icon} size={20} className="text-white" />
              </div>
              <span className="text-xs font-medium text-gray-900 dark:text-white text-center">
                {stage?.stage}
              </span>
            </div>
            
            {index < stages?.length - 1 && (
              <div className="flex-1 h-0.5 bg-gray-300 dark:bg-slate-600 mx-2" />
            )}
          </React.Fragment>
        ))}
      </div>
      <div className="mt-6 pt-6 border-t border-gray-200 dark:border-slate-700">
        <div className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
          <Icon name="Bell" size={16} />
          <span>Automated milestone notifications and deadline alerts enabled</span>
        </div>
      </div>
    </div>
  );
};

export default DealProgressionTracker;